/**
 * Mobile sticky scroll — wraps each sticky dual-tiles section + its next
 * sibling in a group div so the sticky range is limited to that pair.
 * The dual-tile unsticks once the group scrolls out of view.
 */
(function () {
  if (window.matchMedia('(min-width: 750px)').matches) return;

  function init() {
    var markers = document.querySelectorAll('[data-sticky-scroll]');

    markers.forEach(function (el) {
      var section = el.closest('.shopify-section');
      if (!section || section.dataset.stickyGrouped) return;

      var next = section.nextElementSibling;
      if (!next || !next.classList.contains('shopify-section')) return;

      var group = document.createElement('div');
      group.className = 'sticky-scroll-group';
      section.parentNode.insertBefore(group, section);
      group.appendChild(section);
      group.appendChild(next);

      section.dataset.stickyGrouped = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
